<template>
	<div class="floatlogin">
		<el-row>
			<a href="/activity" target="_blank">
				<img src="/images/advertisement.png" width="100%" />
			</a>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {
			
		}
	}
</script>

<style>
</style>
